import { OperatorProfile } from '../types';

const KEY = 'function-check-operator';

export function getOperatorProfile(): OperatorProfile | null {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as OperatorProfile) : null;
  } catch (error) {
    console.warn('Failed to read operator profile', error);
    return null;
  }
}

export function saveOperatorProfile(profile: OperatorProfile): void {
  localStorage.setItem(KEY, JSON.stringify(profile));
}

export function clearOperatorProfile(): void {
  localStorage.removeItem(KEY);
}
